import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
import Counter from '../../NumCounter.js'
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title> Nose Surgery Cost in Delhi | Septoplasty & FESS Guide</title>
            <meta name="description" content="Get affordable nose surgery in Delhi with expert ENT care at ENT Delhi. Transparent pricing & advanced rhinoplasty options. Book your consult today! " />
            <meta name="keywords" content="Nose surgery cost in Delhi, Low Cost FESS in Delhi, Affordable nasal endoscopy in Delhi, Nasal Surgery in Delhi, Affordable septoplasty for deviated septum" />
            <link rel="canonical" href="https://entdelhi.com/nose-surgery-cost-delhi/" />
            <meta property="og:title" content="Open Graph Title" />
            <meta property="og:description" content="Open Graph Description for Facebook etc." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
        <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
